String.prototype.params = function(key){
  const params = this.substr(1).split('&')
  params.map( v => { const p=v.split('=');params[p[0]]=p[1]})
  return key ? params[key]||'' : params
}

const [w,l,d] = [window,location,document]

export default function RECRUIT () {
  const guideline_cat = 2

  const guidelist_init = () => {

    // 詳細ページの場合
    if(l.search.params('article')){
      $.when(
        $.getJSON('/asset/api/getArticles/',{
          content: 'recruit',
          category_in: guideline_cat,
          post_id: l.search.params('article'),
        }),
        w.load['header']
      ).done(data => {
        if(data[0].length){
          d.body.classList.add('is-recruit-guideline')
          $('.p-gnav__subnav-list,.p-recruit-nav-list').currentMenu({mode:0,default:999,url:`/recruit/?mode=list&cat=${guideline_cat}`})
        }
      })
    }

    // 募集要項カテゴリの一覧ページ
    if(l.search.params('cat')==guideline_cat){
      d.body.classList.add('is-recruit-guideline')
      const $catetitle = $('.element_list > .title')
      $catetitle.replaceWith(`
        <h3 class="p-recruit__title"><span>${$catetitle.text()}</span></h3>
      `)
    }
  }
  w.addEventListener('DOMContentLoaded',guidelist_init)
}